module.exports = __webpack_public_path__ + "assets/img/honor1.169d4671.png";